module.exports = __webpack_public_path__ + "static/media/PERSONALIZED_OFFERS_60X50.ce89397b.svg";